<template>
  <div class="foterBlock">
    <!-- <div class="foterBlockUi">
      <div class="logoBlock"  @click="toPath('/PrimarySurface')">
        <img :src="blackCatLogo" alt="blackCatLogo" class="logoImg-class" />
      </div>
      <div class="dividerBlock">
        <el-divider direction="vertical"></el-divider>
      </div>
      <div class="webDescBlock">
        <div class="webDescList ProductListLeft">
          <span>信用报告系列服务</span>
          <p @click="toPath('/ReportInfo?reportType=v1')">供应商准入报告 <icon-endocrine theme="multi-color" size="24" :fill="['#FFF' ,'#ff452f' ,'#FFF' ,'#43CCF8']" /></p>
          <p @click="toPath('/ReportInfo?reportType=v2')">企业信用评价报告</p>
          <p @click="toPath('/ReportInfo?reportType=v3')">企业基础信用报告</p>
          <p @click="toPath('/ReportInfo?reportType=v4')">企业经营风险筛查报告</p>
          <p @click="toPath('/ReportInfo?reportType=v5')">中小企业助贷分析报告</p>
          <i>敬请期待更多信用报告产品</i>
        </div>
        <div class="webDescList GuaranteeListLeft">
          <span>金融产品服务</span>
          <p @click="toPath('/electronicGuarantee')">投标电子保函 <icon-endocrine theme="multi-color" size="24" :fill="['#FFF' ,'#ff452f' ,'#FFF' ,'#43CCF8']" /></p>
          <p @click="toPath('/electronicGuarantee')">履约电子保函</p>
          <p @click="toPath('/financingDemand')">融资需求发布<icon-endocrine theme="multi-color" size="24" :fill="['#FFF' ,'#ff452f' ,'#FFF' ,'#43CCF8']" /></p>
          <i>敬请期待更多金融产品</i>
        </div>
        <div class="webDescList LogoLeft">
          <img :src="khoodysLogo" alt="blackCatLogo" class="logoImg-class" />
          <p>指导单位：商业信用中心</p>
          <p>技术支持：北京金慧迪信息科技有限公司</p>
          <p>平台服务电话：010-58691629 010-66095815</p>
          <p>平台服务时间：工作日AM9:00-12:00 PM13:30-17:30</p>
        </div>
      </div>
    </div>
    <div class="copyRightdivider">
      <el-divider></el-divider>
    </div> -->
    <div class="copyRightBlockUi">
      <span class="copyRight">
        Copyright ©2024 商业信用中心
        <el-divider direction="vertical"></el-divider>
        <!-- <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">赣ICP备 19001357-1 号</a> -->
        <el-divider direction="vertical"></el-divider>
        地址：北京市西城区复兴门内大街45号院主楼
        <el-divider direction="vertical"></el-divider>
        邮编：100801
        <el-divider direction="vertical"></el-divider>
        电话：010-58691629
      </span>
    </div>
  </div>

</template>
<script>
import blackCatLogo from "@/assets/img/blackCatLogo.png";
import khoodysLogo from "@/assets/img/khoodys.png";
export default {
  name: "Footer",
  components: {},
  data() {
    return {
      blackCatLogo: blackCatLogo,
      khoodysLogo: khoodysLogo,
    };
  },
  methods: {
    toPath(path) {
      this.$router.push({
        path: path,
      });
    },
  }
};
</script>
<style scoped>
.foterBlock {
  width: 100%;
  /* height: 400px; */
  background-color: #000;
  min-width: 1366px;
  position: relative;
  padding-top: 20px;
  padding-bottom: 20px;
}

.LogoLeft {
  width: 400px !important;
}
.webDescList {
  /* position: absolute; */
  width: 200px;
  margin-top: 50px;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;
  color: #fff;
}
.webDescList p {
  padding-top: 20px;
  font-size: 15px;
  cursor: pointer;
}
.webDescList i {
  padding-top: 20px;
  font-size: 12px;
}
.webDescList span {
  font-size: 18px;
  font-weight: bold;
}
.dividerBlock .el-divider--vertical {
  height: 350px;
}
.el-divider--horizontal {
  width: 90%;
}
.logoBlock {
  width: 200px;
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100px;
  background-color: #fff;
  position: absolute;
  top: 80px;
  left: 130px;
}
.logoBlock img {
  width: 150px;
}
.dividerBlock {
  position: absolute;
  left: 400px;
}
.copyRightdivider {
  position: absolute;
  bottom: 25px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.copyRightBlockUi {
  position: absolute;
  bottom: 15px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.copyRightBlockUi a {
  color: #fff;
  text-decoration: none;
}
.copyRight {
  width: 85%;
  color: #fff;
  font-size: 15px;
}
.webDescBlock {
  position: absolute;
  left: 450px;
  display: flex;
  align-items: flex-start;
  justify-content: space-around;
  flex-direction: row;
  width: calc(100vw - 550px);
}
</style>



// WEBPACK FOOTER //
// src/views/Layout/components/Footer.vue